import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const RedeemGrid = styled.div`
  width:100%;
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap:20px;

  ${mq(Devices.tablet)} {
    grid-template-columns: 1fr;
    gap:20px;
    padding:0 10px 20px 10px;
  }
`;

